import request from "../../request.js";
import qs from "qs";

// 上次文件
export function uploadFileToYdy(data) {
  return request({
    url: "/ydy-file/uploadFileToYdy",
    method: "POST",
    data,
  });
}
// 上传文件到腾讯云-后端
export function uploadFileToTxCloudEquityFee(data) {
  return request({
    url: "/tx-cloud-file/uploadFileToTxCloudEquityShanxi",
    method: "POST",
    data,
  });
}
// 新增用户
export function addAjefUser(data) {
  return request({
    url: "/ajef-user/addAjefUser",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 获取腾讯云秘钥
export function getPolicyTxCloudEquityFee(data) {
  return request({
    url: "/tx-cloud-file/getPolicyTxCloudEquityShanxi",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 获取用户列表
export function getAjefUserList(data) {
  return request({
    url: "/ajef-user/getAjefUserList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 编辑用户
export function updateAjefUser(data) {
  return request({
    url: "/ajef-user/updateAjefUser",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 登录
export function doLogin(data) {
  return request({
    url: "/ajef-user/doLogin",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 删除用户
export function deleteAjefUser(data) {
  return request({
    url: "/ajef-user/deleteAjefUser",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 新增商户
export function addAjefShop(data) {
  return request({
    url: "/ajef-shop/addAjefShop",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 删除商户
export function deleteAjefShop(data) {
  return request({
    url: "/ajef-shop/deleteAjefShop",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 获取商户
export function getAjefShopList(data) {
  return request({
    url: "/ajef-shop/getAjefShopList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 获取商户-详情
export function getAjefShopDetails(data) {
  return request({
    url: "/ajef-shop/getAjefShopDetails",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 获取商户-编辑
export function updateAjefShop(data) {
  return request({
    url: "/ajef-shop/updateAjefShop",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 获取商户账单
export function getAjefShopBillList(data) {
  return request({
    url: "/ajef-shop-bill/getAjefShopBillList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 批量生成卷
export function addAjefCertificateRecordMulti(data) {
  return request({
    url: "/ajef-certificate-record/addAjefCertificateRecordMulti",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 批量撤销卷
export function cancelAjefCertificateRecordMulti(data) {
  return request({
    url: "/ajef-certificate-record/cancelAjefCertificateRecordMulti",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 查询卷记录
export function getAjefCertificateRecordList(data) {
  return request({
    url: "/ajef-certificate-record/getAjefCertificateRecordList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 新增商户管理员
export function addAjefUserShopAdmin(data) {
  return request({
    url: "/ajef-user-shop/addAjefUserShopAdmin",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 新增商户核销员
export function addAjefUserShopUser(data) {
  return request({
    url: "/ajef-user-shop/addAjefUserShopUser",
    method: "POST",
    data: qs.stringify(data),
  });
}

// 删除商户用户
export function deleteAjefUserShop(data) {
  return request({
    url: "/ajef-user-shop/deleteAjefUserShop",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 获取商户用户
export function getAjefUserShopList(data) {
  return request({
    url: "/ajef-user-shop/getAjefUserShopList",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 编辑商户用户
export function updateAjefUserShop(data) {
  return request({
    url: "/ajef-user-shop/updateAjefUserShop",
    method: "POST",
    data: qs.stringify(data),
  });
}
// 商户账单新
export function getAjefShopBillListp(data) {
  return request({
    url: "/ajef-shop-bill/getAjefShopBillListp",
    method: "POST",
    data: qs.stringify(data),
  });
}
//提现申请
export function getAjefApplyWithdrawList(data) {
  return request({
    url: "/ajef-apply-withdraw/getAjefApplyWithdrawList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//微信账单回调
export function getWxPayNotifyList(data) {
  return request({
    url: "/wx-pay-notify/getWxPayNotifyList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//发票-新增发票通知
export function addAjefShopReceipt(data) {
  return request({
    url: "/ajef-shop-receipt/addAjefShopReceipt",
    method: "POST",
    data: qs.stringify(data),
  });
}
//发票-发票通知
export function getAjefShopReceiptList(data) {
  return request({
    url: "/ajef-shop-receipt/getAjefShopReceiptList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//发票-发票审核
export function updateAjefShopReceiptStatusCheck(data) {
  return request({
    url: "/ajef-shop-receipt/updateAjefShopReceiptStatusCheck",
    method: "POST",
    data: qs.stringify(data),
  });
}
//发票-发票通知
export function updateAjefShopReceiptStatusSend(data) {
  return request({
    url: "/ajef-shop-receipt/updateAjefShopReceiptStatusSend",
    method: "POST",
    data: qs.stringify(data),
  });
}
//对公打款编辑账单信息
export function updateAjefApplyWithdrawPayment(data) {
  return request({
    url: "/ajef-apply-withdraw/updateAjefApplyWithdrawPayment",
    method: "POST",
    data: qs.stringify(data),
  });
}
//用户修改密码
export function updateAjefUserPw(data) {
  return request({
    url: "/ajef-user/updateAjefUserPw",
    method: "POST",
    data: qs.stringify(data),
  });
}
//商户审核-通过
export function updateAjefShopCheckPass(data) {
  return request({
    url: "/ajef-shop/updateAjefShopCheckPass",
    method: "POST",
    data: qs.stringify(data),
  });
}
//商户审核-不通过
export function updateAjefShopCheckNotPass(data) {
  return request({
    url: "/ajef-shop/updateAjefShopCheckNotPass",
    method: "POST",
    data: qs.stringify(data),
  });
}
//商户账单-详情
export function getAjefShopBillDetails(data) {
  return request({
    url: "/ajef-shop-bill/getAjefShopBillDetails",
    method: "POST",
    data: qs.stringify(data),
  });
}
//商户开票结算类型
export function getAjefShopReceiptTypeList(data) {
  return request({
    url: "/ajef-shop-receipt-type/getAjefShopReceiptTypeList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//系统日志
export function getSysLogList(data) {
  return request({
    url: "/sys-log/getSysLogList",
    method: "POST",
    data,
  });
}
//新增银行卡可选范围
export function addAjefShopBankOptinons(data) {
  return request({
    url: "/ajef-shop-bank-optinons/addAjefShopBankOptinons",
    method: "POST",
    data: qs.stringify(data),
  });
}
//编辑银行可选范围
export function updateAjefShopBankOptinons(data) {
  return request({
    url: "/ajef-shop-bank-optinons/updateAjefShopBankOptinons",
    method: "POST",
    data: qs.stringify(data),
  });
}
//删除银行可选范围
export function deleteAjefShopBankOptinons(data) {
  return request({
    url: "/ajef-shop-bank-optinons/deleteAjefShopBankOptinons",
    method: "POST",
    data: qs.stringify(data),
  });
}
//获取银行可选范围
export function getAjefShopBankOptinonsList(data) {
  return request({
    url: "/ajef-shop-bank-optinons/getAjefShopBankOptinonsList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//商户用户列表
export function getAjefUserShopBindList(data) {
  return request({
    url: "/ajef-user-shop-bind/getAjefUserShopBindList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//查询地区
export function getSysRegionList(data) {
  return request({
    url: "/sys-region/getSysRegionList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//商户充值奖励请
export function updateAjefShopCheckPassGift(data) {
  return request({
    url: "/ajef-shop/updateAjefShopCheckPassGift",
    method: "POST",
    data: qs.stringify(data),
  });
}
//新增地区信息
export function addSysRegion(data) {
  return request({
    url: "/sys-region/addSysRegion",
    method: "POST",
    data: qs.stringify(data),
  });
}
//编辑地区信息
export function updateSysRegion(data) {
  return request({
    url: "/sys-region/updateSysRegion",
    method: "POST",
    data: qs.stringify(data),
  });
}
//删除地区信息
export function deleteSysRegion(data) {
  return request({
    url: "/sys-region/deleteSysRegion",
    method: "POST",
    data: qs.stringify(data),
  });
}
//获取权限列表
export function getAjefAuthList(data) {
  return request({
    url: "/ajef-auth/getAjefAuthList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//新增权限列表
export function addAjefAuth(data) {
  return request({
    url: "/ajef-auth/addAjefAuth",
    method: "POST",
    data: qs.stringify(data),
  });
}
//删除权限列表
export function deleteAjefAuth(data) {
  return request({
    url: "/ajef-auth/deleteAjefAuth",
    method: "POST",
    data: qs.stringify(data),
  });
}
//编辑权限列表
export function updateAjefAuth(data) {
  return request({
    url: "/ajef-auth/updateAjefAuth",
    method: "POST",
    data: qs.stringify(data),
  });
}
//获取树权限列表
export function getAjefAuthTree(data) {
  return request({
    url: "/ajef-auth/getAjefAuthTree",
    method: "POST",
    data: qs.stringify(data),
  });
}
//新建角色
export function addAjefRole(data) {
  return request({
    url: "/ajef-role/addAjefRole",
    method: "POST",
    data: qs.stringify(data),
  });
}
//删除角色
export function deleteAjefRole(data) {
  return request({
    url: "/ajef-role/deleteAjefRole",
    method: "POST",
    data: qs.stringify(data),
  });
}
//获取角色权限
export function getAjefRoleAuthList(data) {
  return request({
    url: "/ajef-role/getAjefRoleAuthList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//获取角色列表
export function getAjefRoleList(data) {
  return request({
    url: "/ajef-role/getAjefRoleList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//编辑角色列表
export function updateAjefRole(data) {
  return request({
    url: "/ajef-role/updateAjefRole",
    method: "POST",
    data: qs.stringify(data),
  });
}
//编辑角色权限
export function updateAjefRoleAuth(data) {
  return request({
    url: "/ajef-role/updateAjefRoleAuth",
    method: "POST",
    data: qs.stringify(data),
  });
}
//开票结算类型审核列表
export function getAjefShopReceiptTypeChangeApplyList(data) {
  return request({
    url: "/ajef-shop-receipt-type-change-apply/getAjefShopReceiptTypeChangeApplyList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//开票结算类型审核-不通过
export function updateAjefShopReceiptTypeCheckNotPass(data) {
  return request({
    url: "/ajef-shop-receipt-type-change-apply/updateAjefShopReceiptTypeCheckNotPass",
    method: "POST",
    data: qs.stringify(data),
  });
}
//开票结算类型审核-通过
export function updateAjefShopReceiptTypeCheckPass(data) {
  return request({
    url: "/ajef-shop-receipt-type-change-apply/updateAjefShopReceiptTypeCheckPass",
    method: "POST",
    data: qs.stringify(data),
  });
}
//卡劵规格-新增
export function addAjefCertificateRecordRelationXiaoxiang(data) {
  return request({
    url: "/ajef-certificate-record-relation-xiaoxiang/addAjefCertificateRecordRelationXiaoxiang",
    method: "POST",
    data: qs.stringify(data),
  });
}
//卡劵规格-编辑
export function updateAjefCertificateRecordRelationXiaoxiang(data) {
  return request({
    url: "/ajef-certificate-record-relation-xiaoxiang/updateAjefCertificateRecordRelationXiaoxiang",
    method: "POST",
    data: qs.stringify(data),
  });
}
//卡劵规格-编辑
export function getAjefCertificateRecordRelationXiaoxiangList(data) {
  return request({
    url: "/ajef-certificate-record-relation-xiaoxiang/getAjefCertificateRecordRelationXiaoxiangList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//卡劵规格-删除
export function deleteAjefCertificateRecordRelationXiaoxiang(data) {
  return request({
    url: "/ajef-certificate-record-relation-xiaoxiang/deleteAjefCertificateRecordRelationXiaoxiang",
    method: "POST",
    data: qs.stringify(data),
  });
}
//新增移动公司存量客户
export function addAjefShopStockYidong(data) {
  return request({
    url: "/ajef-shop-stock-yidong/addAjefShopStockYidong",
    method: "POST",
    data: qs.stringify(data),
  });
}
//编辑移动公司存量客户
export function updateAjefShopStockYidong(data) {
  return request({
    url: "/ajef-shop-stock-yidong/updateAjefShopStockYidong",
    method: "POST",
    data: qs.stringify(data),
  });
}
//删除移动公司存量客户
export function deleteAjefShopStockYidong(data) {
  return request({
    url: "/ajef-shop-stock-yidong/deleteAjefShopStockYidong",
    method: "POST",
    data: qs.stringify(data),
  });
}
//获取移动公司存量客户
export function getAjefShopStockYidongList(data) {
  return request({
    url: "/ajef-shop-stock-yidong/getAjefShopStockYidongList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//批量导入移动公司存量客户
export function uploadAjefShopStockYidong(data) {
  return request({
    url: "/ajef-shop-stock-yidong/uploadAjefShopStockYidong",
    method: "POST",
    data,
  });
}
//主页获取用户权限
export function getAjefUserDetailsRefresh(data) {
  return request({
    url: "/ajef-user/getAjefUserDetailsRefresh",
    method: "POST",
    data: qs.stringify(data),
  });
}
//主页获取用户所有通知
export function getAjefUserNoticeTotal(data) {
  return request({
    url: "/ajef-user/getAjefUserNoticeTotal",
    method: "POST",
    data: qs.stringify(data),
  });
}
//主页获取用户所有通知数量
export function getAjefUserNoticeTotalNum(data) {
  return request({
    url: "/ajef-user/getAjefUserNoticeTotalNum",
    method: "POST",
    data: qs.stringify(data),
  });
}
//商户审核查询
export function updateAjefShopCheckBefore(data) {
  return request({
    url: "/ajef-shop/updateAjefShopCheckBefore",
    method: "POST",
    data: qs.stringify(data),
  });
}
//新增商品兑换收集
export  function addAjefShopCollectionGoods(data) {
	return request({
		url: "/ajef-shop-collection-goods/addAjefShopCollectionGoods",
		method: "POST",
		data:qs.stringify(data)
	})
}
//查询商品兑换收集
export  function getAjefShopCollectionGoodsList(data) {
	return request({
		url: "/ajef-shop-collection-goods/getAjefShopCollectionGoodsList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑商品兑换收集
export  function updateAjefShopCollectionGoods(data) {
	return request({
		url: "/ajef-shop-collection-goods/updateAjefShopCollectionGoods",
		method: "POST",
		data:qs.stringify(data)
	})
}
//暂停商品兑换收集
export  function updateAjefShopCollectionGoodsDown(data) {
	return request({
		url: "/ajef-shop-collection-goods/updateAjefShopCollectionGoodsDown",
		method: "POST",
		data:qs.stringify(data)
	})
}
//发布商品兑换收集
export  function updateAjefShopCollectionGoodsUp(data) {
	return request({
		url: "/ajef-shop-collection-goods/updateAjefShopCollectionGoodsUp",
		method: "POST",
		data:qs.stringify(data)
	})
}
//查询商户上传商品兑换收集
export  function getAjefShopCollectionGoodsRecordList(data) {
	return request({
		url: "/ajef-shop-collection-goods-record/getAjefShopCollectionGoodsRecordList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//删除商户上传商品兑换收集
export  function deleteAjefShopCollectionGoodsRecord(data) {
	return request({
		url: "/ajef-shop-collection-goods-record/deleteAjefShopCollectionGoodsRecord",
		method: "POST",
		data:qs.stringify(data)
	})
}
//地市权限查询核销账单
export  function getAjefShopBillListCustomer(data) {
	return request({
		url: "/certificate_record-customer/getAjefShopBillListCustomer",
		method: "POST",
		data:qs.stringify(data)
	})
}
//地市权限查询商户
export  function getAjefShopListCustomer(data) {
	return request({
		url: "/certificate_record-customer/getAjefShopListCustomer",
		method: "POST",
		data:qs.stringify(data)
	})
}
//查询商户地市
export  function getAjefShopCityList(data) {
	return request({
		url: "/ajef-shop-city/getAjefShopCityList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//账单-退款申请
export  function getAjefShopBillRevokeList(data) {
	return request({
		url: "/ajef-shop-bill-revoke/getAjefShopBillRevokeList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//账单-退款申请-处理
export  function updateAjefShopBillRevokeHandler(data) {
	return request({
		url: "/ajef-shop-bill-revoke/updateAjefShopBillRevokeHandler",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑关键值
export  function updateSysOurageKey(data) {
	return request({
		url: "/sys-ourage-key/updateSysOurageKey",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑关键值
export  function getSysOurageKeyList(data) {
	return request({
		url: "/sys-ourage-key/getSysOurageKeyList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//批量导入已入账发票信息
export  function uploadAjefShopReceiptInBill(data) {
	return request({
		url: "/ajef-shop-receipt/uploadAjefShopReceiptInBill",
		method: "POST",
		data
	})
}
//财务统计 -总的
export  function getAjefCertificateRecordStatisticsYear(data) {
	return request({
		url: "/ajef-certificate-record-statistics/getAjefCertificateRecordStatisticsYear",
		method: "POST",
			data:qs.stringify(data)
	})
}
//财务统计 -商户总的
export  function getAjefCertificateRecordStatisticsYearShop(data) {
	return request({
		url: "/ajef-certificate-record-statistics/getAjefCertificateRecordStatisticsYearShop",
		method: "POST",
			data:qs.stringify(data)
	})
}
//通知-查询
export  function getSysNoticeList(data) {
	return request({
		url: "/sys-notice/getSysNoticeList",
		method: "POST",
			data:qs.stringify(data)
	})
}
//通知-删除
export  function deleteSysNoticeRead(data) {
	return request({
		url: "/sys-notice/deleteSysNoticeRead",
		method: "POST",
			data:qs.stringify(data)
	})
}
//通知-分类标题
export  function getSysNoticeListTitle(data) {
	return request({
		url: "/sys-notice/getSysNoticeListTitle",
		method: "POST",
			data:qs.stringify(data)
	})
}
//通知-已读
export  function updateSysNoticeRead(data) {
	return request({
		url: "/sys-notice/updateSysNoticeRead",
		method: "POST",
			data:qs.stringify(data)
	})
}
//通知-未通知数量
export  function getSysNoticeUnReadNum(data) {
	return request({
		url: "/sys-notice/getSysNoticeUnReadNum",
		method: "POST",
			data:qs.stringify(data)
	})
}
//通知-一键已读
export  function updateSysNoticeReadAll(data) {
	return request({
		url: "/sys-notice/updateSysNoticeReadAll",
		method: "POST",
			data:qs.stringify(data)
	})
}
//新增子商户
export  function addAjefShopChild(data) {
	return request({
		url: "/ajef-shop/addAjefShopChild",
		method: "POST",
			data:qs.stringify(data)
	})
}
//获取易宝通订单记录
export  function getYbtOrderList(data) {
	return request({
		url: "/ybt-order/getYbtOrderList",
		method: "POST",
			data:qs.stringify(data)
	})
}

//获取微信用户
export  function getAjefUserWxList(data) {
	return request({
		url: "/ajef-user-wx/getAjefUserWxList",
		method: "POST",
			data:qs.stringify(data)
	})
}

//获取易宝通订单详情
export  function getYbtOrderDetails(data) {
	return request({
		url: "/ybt-order/getYbtOrderDetails",
		method: "POST",
			data:qs.stringify(data)
	})
}
//获取易宝通售后记录
export  function getYbtOrderSalesAfterList(data) {
	return request({
		url: "/ybt-order-sales-after/getYbtOrderSalesAfterList",
		method: "POST",
			data:qs.stringify(data)
	})
}
//获取易宝通售后记录
export  function getAjefOrderBillList(data) {
	return request({
		url: "/ajef-order-bill/getAjefOrderBillList",
		method: "POST",
			data:qs.stringify(data)
	})
}

//批量导入-商户用户
export  function uploadAjefUserShop(data) {
	return request({
		url: "/ajef-user-shop/uploadAjefUserShop",
		method: "POST",
			data
	})
}
//用户-每月结算记录
export  function getAjefOrderSettlementWxList(data) {
	return request({
		url: "/ajef-order-settlement-wx/getAjefOrderSettlementWxList",
		method: "POST",
			data:qs.stringify(data)
	})
}
//商户 - 新增商户用户分组
export  function addAjefUserGroup(data) {
	return request({
		url: "/ajef-user-group/addAjefUserGroup",
		method: "POST",
			data:qs.stringify(data)
	})
}
//商户 - 编辑商户用户分组
export  function updateAjefUserGroup(data) {
	return request({
		url: "/ajef-user-group/updateAjefUserGroup",
		method: "POST",
			data:qs.stringify(data)
	})
}
//商户 - 获取商户用户分组
export  function getAjefUserGroupList(data) {
	return request({
		url: "/ajef-user-group/getAjefUserGroupList",
		method: "POST",
			data:qs.stringify(data)
	})
}
//商户 - 删除商户用户分组
export  function deleteAjefUserGroup(data) {
	return request({
		url: "/ajef-user-group/deleteAjefUserGroup",
		method: "POST",
			data:qs.stringify(data)
	})
}
//日志-活跃统计
export function getSysLogStatisticsList(data) {
  return request({
    url: "/sys-log-statistics/getSysLogStatisticsList",
    method: "POST",
    data: qs.stringify(data),
  });
}
//日志-活跃统计时间段
export function getSysLogStatisticsDetails(data) {
  return request({
    url: "/sys-log-statistics/getSysLogStatisticsDetails",
    method: "POST",
    data: qs.stringify(data),
  });
}